// Toggle the menu open and close when on mobile
const ems = {};
ems['em-support'] = 'c3VwcG9ydEBwbGF0enBsYW5lci5hdA==';
ems['em-dk'] = 'ZG9taW5pay5rcmFuemxAZ21haWwuY29t';
ems['em-tel-dk'] = 'KzQzNjY0NzMwOTUzNTM=';

export default function showEMailAdress() {

    function findEM(link) {
        for(let em in ems) {
            if(link.classList.contains(em)) {
                return ems[em];
            }
        }
    }

    function addEvent(link) {
        link.addEventListener('click', function(event) {
            if(!link.classList.contains('em-inserted')) {
                event.preventDefault();
                link.classList.add('em-inserted');
                let encryptedEM = findEM(link);
                const em = atob(encryptedEM);

                let preHref = 'mailto:';
                if(link.classList.contains('em-tel')) {
                    preHref = 'tel:';
                }

                link.setAttribute("href", preHref.concat(em));
                link.textContent = em;
            }
        });
    }

    const links = document.querySelectorAll('a.insert-em');
    links.forEach(link => addEvent(link));


}

